module.exports = __webpack_public_path__ + "media/images/pages/logo-color-63a10ffefdbe2cd32bcd90179f693b76.png";